<template>
  <div class="c-filter">
    <div class="c-btn"></div>
    <div class="c-form">
      <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="月份">
          <ElDatePicker type="month" v-model="month" @change="sendEvent" placeholder="不限" value-format="yyyy-MM" style="width: 180px">
          </ElDatePicker>
        </ElFormItem>
        <ElFormItem label="游戏">
          <ThrottleSelector
            v-model="gameId"
            :list="gameData"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>
        <ElFormItem label="媒体">
          <ThrottleSelector
            v-model="mediaId"
            :list="medias"
            @change="sendEvent"
            style="width: 160px"
            placeholder="全部"
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem class="bg-transparent" label-width="0">
          <Button type="primary" @click="$emit('on-set')">录入自然量充值比</Button>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import ThrottleSelector from '@/components/throttle-select/index.vue'
export default {
  name: 'recordKpi',
  components: { ThrottleSelector },
  props: {
    medias: {
      type: Array,
      default() {
        return []
      }
    },
    gameData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    sendEvent() {
      const params = {
        mediaId: this.mediaId === -1 ? undefined : this.mediaId,
        gameId: this.gameId === '' ? undefined : this.gameId,
        tdateMonth: this.month === '' ? undefined : this.month
      }
      this.$emit('on-change', params)
    },
    preUpload(file) {
      this.emitImport(file)
      return false
    },
    emitImport(file) {
      this.$emit('on-import', file)
    }
  },
  data() {
    return {
      month: '', // 月份
      mediaId: '',
      gameId: ''
    }
  },
  created() {
    this.sendEvent()
  }
}
</script>
